import { DayOfWeek, TimeOfDay, WaitlistEntry } from '@dreryk/egabinet-waitlist-frontend-api';
import { PatientSimple } from '@dreryk/egabinet-patient-frontend-api';

import { getCustomFormattingContext, patientNameFormatter, phoneNumberFormatter } from '@dreryk/react-common';

export const DAYS_OF_WEEK: readonly DayOfWeek[] = [
   'MONDAY',
   'TUESDAY',
   'WEDNESDAY',
   'THURSDAY',
   'FRIDAY',
   'SATURDAY',
   'SUNDAY',
];

export const TIMES_OF_DAY: readonly TimeOfDay[] = ['MORNING', 'AFTERNOON', 'EVENING'];

export const getFormattedPatientName = (entry: WaitlistEntry, patient: PatientSimple): string => {
   const formattedPatientName =
      patientNameFormatter(entry.patient, getCustomFormattingContext({ options: { order: 'firstLast' } })) ?? '';
   const parts = [formattedPatientName];
   if (patient.formattedAge) {
      parts.push(patient.formattedAge);
   }
   return parts.join(', ');
};

export const getFormattedPatientPhoneNumber = (entry: WaitlistEntry, patient: PatientSimple): string | null =>
   phoneNumberFormatter(patient.phoneNumber) ?? phoneNumberFormatter(entry.patient.phoneNumber);

export const getFormattedPractitionerName = (entry: WaitlistEntry): string =>
   `${entry.practitioner.firstName.asString()} ${entry.practitioner.lastName.asString()}`;

export const isAllPatientAvailabilityTimesSelected = (times: TimeOfDay[]): boolean =>
   times.length === TIMES_OF_DAY.length;

export const sortPatientAvailabilityTimesByDayOrder = (times: TimeOfDay[]): TimeOfDay[] =>
   [...times].sort((first, second) => TIMES_OF_DAY.indexOf(first) - TIMES_OF_DAY.indexOf(second));

export const getPatientAvailabilityDays = (patientAvailability: WaitlistEntry['patientAvailability']): DayOfWeek[] =>
   DAYS_OF_WEEK.filter((day) => (patientAvailability[day]?.length ?? 0) > 0);

export const isPatientAvailabilityWholeWeek = (patientAvailability: WaitlistEntry['patientAvailability']): boolean => {
   const timesOfDay = Object.values(patientAvailability);
   const allTimesSelected = timesOfDay.every((times) => times.length === TIMES_OF_DAY.length);
   return timesOfDay.length === DAYS_OF_WEEK.length && allTimesSelected;
};
